import * as React from "react";
import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { ltlFieldInputId } from "@taskpane/utils/ltlValidationFocus";
import { routeShipmentDetailInput } from "./shipmentDetailsFieldRouting";

interface ShipmentDetailsZipsAndDateProps {
  state: LTLState;
  onFieldChange: (field: keyof LTLState["form"], value: string) => void;
  onFieldBlur?: () => void;
  getTextFieldStyles: (fieldName: keyof LTLState["form"]) => Partial<ITextFieldStyles>;
}

export function ShipmentDetailsZipsAndDate({
  state,
  onFieldChange,
  onFieldBlur,
  getTextFieldStyles,
}: ShipmentDetailsZipsAndDateProps): React.ReactElement {
  const handleInputChange = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    const { name } = event.currentTarget;
    const el = event.currentTarget as HTMLInputElement | HTMLTextAreaElement;
    const resolved = newValue !== undefined && newValue !== null ? newValue : (el.value ?? "");

    routeShipmentDetailInput(name, resolved, onFieldChange);
  };

  return (
    <>
      <TextField
        label="Origin ZIP"
        name="originZip"
        value={state.form.originZip}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        required
        id={ltlFieldInputId("originZip")}
        styles={getTextFieldStyles("originZip")}
        errorMessage={state.errors.originZip}
      />
      <TextField
        label="Origin State"
        name="originState"
        value={state.form.originState}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("originState")}
        styles={getTextFieldStyles("originState")}
      />
      <TextField
        label="Destination ZIP"
        name="destinationZip"
        value={state.form.destinationZip}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        required
        id={ltlFieldInputId("destinationZip")}
        styles={getTextFieldStyles("destinationZip")}
        errorMessage={state.errors.destinationZip}
      />
      <TextField
        label="Destination State"
        name="destinationState"
        value={state.form.destinationState}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("destinationState")}
        styles={getTextFieldStyles("destinationState")}
      />
      <TextField
        label="Pickup Date"
        name="pickupDate"
        value={state.form.pickupDate}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        type="date"
        required
        id={ltlFieldInputId("pickupDate")}
        styles={getTextFieldStyles("pickupDate")}
        errorMessage={state.errors.pickupDate}
      />
    </>
  );
}
